import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatBadgeModule } from "@angular/material/badge";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ChartsComponent } from "./charts.component";
import { LineChartModule } from "./line-chart/line-chart.module";
import { BarChartModule } from "./bar-chart/bar-chart.module";
import { PieChartModule } from "./pie-chart/pie-chart.module";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { PolarChartModule } from "./polar-chart/polar-chart.module";
import { OriginChartModule } from "./origin-chart/origin-chart.module";
import { MatCardModule } from "@angular/material/card";
import { LoaderModule } from "../../../../shared/components/loader/loader.module";
import { SharedModule } from "../../../../shared/shared.module";

@NgModule({
  declarations: [
    ChartsComponent
  ],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
    LoaderModule,
    LineChartModule,
    OriginChartModule,
    BarChartModule,
    PieChartModule,
    PolarChartModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatCardModule
  ],
  exports: [
    ChartsComponent
  ]
})
export class ChartsModule { }